import { onINP } from 'web-vitals/attribution';
import type { INPMetricWithAttribution } from 'web-vitals/attribution';
import type { MetricReport } from '../contracts/metricReport';
import { toInpReport } from './mappers';

const onInteractionToNextPaint = (report: (m: MetricReport) => void): void => {
  onINP((metric: INPMetricWithAttribution) => {
    report(toInpReport(metric));
  });
};

export default onInteractionToNextPaint;
